import React, { Component } from 'react';
import MobileStores from './mobileStores';
import PCStores from './PCStores'
import MediaQuery from "react-responsive";

class Stores extends Component { 
  render(){
    return (
      <div>
        <MediaQuery query="(max-width: 1024px)">
          <MobileStores />
        </MediaQuery>
        <MediaQuery query="(min-width: 1025px)">
          <PCStores />
        </MediaQuery>
      </div>
    );
  }
}

export default Stores;